module.exports = __webpack_public_path__ + "static/media/diema-sport-2.80e82afb.png";